(function () {
  var linkSelector = "[data-product-style-link]";
  var productRootSelector = ".shopify-section.product-template";
  var metadataSelector = "[data-product-style-metadata]";
  var statusSelector = "[data-product-style-status]";
  var transitionDuration = 160;
  var sectionCache = {};
  var prefetchRequests = {};
  var navigationSequence = 0;
  var activeController = null;

  function getStyleLink(event) {
    var target = event.target;

    if (!target || !target.closest) {
      return null;
    }

    return target.closest(linkSelector);
  }

  function getProductRoot(element) {
    if (!element || !element.closest) {
      return null;
    }

    return element.closest(productRootSelector);
  }

  function getCurrentProductRoot() {
    return document.querySelector(productRootSelector);
  }

  function getSectionId(productRoot) {
    var prefix = "shopify-section-";

    if (!productRoot || productRoot.id.indexOf(prefix) !== 0) {
      return "";
    }

    return productRoot.id.slice(prefix.length);
  }

  function getNavigationUrl(href) {
    var url = new URL(href, window.location.href);

    if (url.origin !== window.location.origin) {
      return null;
    }

    return url;
  }

  function getCacheKey(url, sectionId) {
    return sectionId + "::" + url.pathname + url.search;
  }

  function getSectionUrl(url, sectionId) {
    var sectionUrl = new URL(url.href);

    sectionUrl.hash = "";
    sectionUrl.searchParams.set("section_id", sectionId);
    return sectionUrl;
  }

  function requestSection(url, sectionId, signal) {
    var cacheKey = getCacheKey(url, sectionId);
    var sectionUrl;

    if (sectionCache[cacheKey]) {
      return Promise.resolve(sectionCache[cacheKey]);
    }

    sectionUrl = getSectionUrl(url, sectionId);

    return fetch(sectionUrl.href, {
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
      signal: signal,
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Product section request failed: " + response.status);
        }

        return response.text();
      })
      .then(function (html) {
        if (!html.trim() || html.trim() === "null") {
          throw new Error("Product section response was empty");
        }

        sectionCache[cacheKey] = html;
        return html;
      });
  }

  function getSectionHtml(url, sectionId, signal) {
    var cacheKey = getCacheKey(url, sectionId);

    if (sectionCache[cacheKey]) {
      return Promise.resolve(sectionCache[cacheKey]);
    }

    if (prefetchRequests[cacheKey]) {
      return prefetchRequests[cacheKey];
    }

    return requestSection(url, sectionId, signal);
  }

  function parseSection(html, sectionId) {
    var parsedDocument = new DOMParser().parseFromString(html, "text/html");
    var nextRoot = parsedDocument.getElementById(
      "shopify-section-" + sectionId
    );

    if (!nextRoot || !nextRoot.matches(productRootSelector)) {
      throw new Error("Destination product section is incompatible");
    }

    if (!nextRoot.querySelector("[data-product-style-switcher]")) {
      throw new Error("Destination product section has no Style switcher");
    }

    return document.importNode(nextRoot, true);
  }

  function decodeHtmlEntities(value) {
    var textarea;

    if (!value || value.indexOf("&") === -1) {
      return value;
    }

    textarea = document.createElement("textarea");
    textarea.innerHTML = value;
    return textarea.value;
  }

  function readMetadata(productRoot) {
    var metadataElement = productRoot.querySelector(metadataSelector);
    var metadata;

    if (!metadataElement) {
      return {};
    }

    try {
      metadata = JSON.parse(metadataElement.textContent);
      metadata.title = decodeHtmlEntities(metadata.title);
      metadata.description = decodeHtmlEntities(metadata.description);
      metadata.productTitle = decodeHtmlEntities(metadata.productTitle);
      return metadata;
    } catch (error) {
      return {};
    }
  }

  function updateMetaContent(selector, value) {
    var element;

    if (!value) {
      return;
    }

    element = document.querySelector(selector);

    if (element) {
      element.setAttribute("content", value);
    }
  }

  function updateDocumentMetadata(metadata) {
    var canonical;

    if (metadata.title) {
      document.title = metadata.title;
      updateMetaContent('meta[property="og:title"]', metadata.title);
      updateMetaContent('meta[name="twitter:title"]', metadata.title);
    }

    if (metadata.canonicalUrl) {
      canonical = document.querySelector('link[rel="canonical"]');

      if (canonical) {
        canonical.setAttribute("href", metadata.canonicalUrl);
      }

      updateMetaContent('meta[property="og:url"]', metadata.canonicalUrl);
    }

    if (metadata.description) {
      updateMetaContent('meta[name="description"]', metadata.description);
      updateMetaContent(
        'meta[property="og:description"]',
        metadata.description
      );
      updateMetaContent(
        'meta[name="twitter:description"]',
        metadata.description
      );
    }
  }

  function setStatus(productRoot, message) {
    var status = productRoot && productRoot.querySelector(statusSelector);

    if (status) {
      status.textContent = message;
    }
  }

  function clearBusyState(productRoot) {
    var busyLinks;
    var index;

    if (!productRoot) {
      return;
    }

    productRoot.classList.remove("is-style-loading", "is-style-leaving");
    productRoot.style.minHeight = "";
    busyLinks = productRoot.querySelectorAll(
      linkSelector + '[aria-busy="true"]'
    );

    for (index = 0; index < busyLinks.length; index += 1) {
      busyLinks[index].removeAttribute("aria-busy");
    }
  }

  function waitForExitTransition() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      window.setTimeout(resolve, transitionDuration);
    });
  }

  function destroyProductWidgets(productRoot) {
    var galleries;
    var index;
    var instance;

    if (
      !productRoot ||
      !window.Flickity ||
      typeof window.Flickity.data !== "function"
    ) {
      return;
    }

    galleries = productRoot.querySelectorAll(".flickity-enabled");

    for (index = 0; index < galleries.length; index += 1) {
      instance = window.Flickity.data(galleries[index]);

      if (instance && typeof instance.destroy === "function") {
        instance.destroy();
      }
    }
  }

  function isExecutableScript(script) {
    var type = (script.getAttribute("type") || "").toLowerCase();

    return (
      !type ||
      type === "text/javascript" ||
      type === "application/javascript" ||
      type === "module"
    );
  }

  function activateSectionScripts(productRoot) {
    var scripts = productRoot.querySelectorAll("script");
    var index;
    var originalScript;
    var replacementScript;
    var attributeIndex;
    var attribute;
    var code;

    for (index = 0; index < scripts.length; index += 1) {
      originalScript = scripts[index];

      if (!isExecutableScript(originalScript)) {
        continue;
      }

      code = originalScript.textContent || "";

      if (!originalScript.src && code.indexOf("DOMContentLoaded") !== -1) {
        continue;
      }

      replacementScript = document.createElement("script");

      for (
        attributeIndex = 0;
        attributeIndex < originalScript.attributes.length;
        attributeIndex += 1
      ) {
        attribute = originalScript.attributes[attributeIndex];
        replacementScript.setAttribute(attribute.name, attribute.value);
      }

      if (originalScript.src) {
        replacementScript.async = false;
      } else {
        replacementScript.text = code;
      }

      originalScript.parentNode.replaceChild(replacementScript, originalScript);
    }
  }

  function applyRequestedVariant(productRoot, url) {
    var variantId = url.searchParams.get("variant");
    var variantSelectors;
    var selectorIndex;
    var options;
    var optionIndex;
    var matchingOption;

    if (!variantId) {
      return;
    }

    variantSelectors = productRoot.querySelectorAll(
      '.product_form select[name="id"]'
    );

    for (
      selectorIndex = 0;
      selectorIndex < variantSelectors.length;
      selectorIndex += 1
    ) {
      options = variantSelectors[selectorIndex].options;
      matchingOption = null;

      for (optionIndex = 0; optionIndex < options.length; optionIndex += 1) {
        options[optionIndex].removeAttribute("selected");

        if (options[optionIndex].value === variantId) {
          matchingOption = options[optionIndex];
        }
      }

      if (matchingOption) {
        matchingOption.setAttribute("selected", "selected");
        variantSelectors[selectorIndex].value = variantId;
      }
    }
  }

  function reinitializeProductSection(productRoot, sectionId) {
    var sectionLoadEvent;

    if (window.jQuery) {
      window.jQuery("body").off("change", ".swatch :radio");
    }

    activateSectionScripts(productRoot);

    sectionLoadEvent = new CustomEvent("shopify:section:load", {
      bubbles: true,
      detail: {
        sectionId: sectionId,
      },
    });
    document.dispatchEvent(sectionLoadEvent);

    if (
      window.Shopify &&
      window.Shopify.PaymentButton &&
      typeof window.Shopify.PaymentButton.init === "function"
    ) {
      window.setTimeout(function () {
        window.Shopify.PaymentButton.init();
      }, 0);
    }

    if (
      window.lazySizes &&
      window.lazySizes.loader &&
      typeof window.lazySizes.loader.checkElems === "function"
    ) {
      window.lazySizes.loader.checkElems();
    }
  }

  function maintainSwitcherPosition(previousTop, productRoot) {
    var nextSwitcher = productRoot.querySelector(
      "[data-product-style-switcher]"
    );
    var nextTop;

    if (!nextSwitcher) {
      return;
    }

    nextTop = nextSwitcher.getBoundingClientRect().top;
    window.scrollBy(0, nextTop - previousTop);
  }

  function finishEntrance(productRoot) {
    window.requestAnimationFrame(function () {
      productRoot.style.minHeight = "";

      window.setTimeout(function () {
        productRoot.classList.remove("is-style-entering");
      }, transitionDuration);
    });
  }

  function getCurrentProductPath(productRoot) {
    var currentLink =
      productRoot &&
      productRoot.querySelector(linkSelector + '[aria-current="page"]');
    var currentUrl = currentLink && getNavigationUrl(currentLink.href);

    return currentUrl ? currentUrl.pathname : window.location.pathname;
  }

  function isKnownStylePath(productRoot, pathname) {
    var links = productRoot.querySelectorAll(linkSelector);
    var index;
    var url;

    for (index = 0; index < links.length; index += 1) {
      url = getNavigationUrl(links[index].href);

      if (url && url.pathname === pathname) {
        return true;
      }
    }

    return false;
  }

  function navigateToProduct(url, options) {
    var productRoot = getCurrentProductRoot();
    var sectionId = getSectionId(productRoot);
    var currentNavigation = (navigationSequence += 1);
    var clickedLink = options.clickedLink;
    var previousSwitcher;
    var previousTop;
    var previousHeight;
    var requestSignal;

    if (!productRoot || !sectionId) {
      window.location.assign(url.href);
      return;
    }

    if (activeController) {
      activeController.abort();
    }

    activeController = window.AbortController ? new AbortController() : null;
    requestSignal = activeController ? activeController.signal : undefined;
    previousSwitcher = productRoot.querySelector(
      "[data-product-style-switcher]"
    );
    previousTop = previousSwitcher
      ? previousSwitcher.getBoundingClientRect().top
      : 0;
    previousHeight = productRoot.getBoundingClientRect().height;

    productRoot.classList.add("is-style-loading");
    productRoot.style.minHeight = previousHeight + "px";
    setStatus(productRoot, "Loading product style");

    if (clickedLink) {
      clickedLink.setAttribute("aria-busy", "true");
    }

    getSectionHtml(url, sectionId, requestSignal)
      .then(function (html) {
        var nextRoot;
        var metadata;

        if (currentNavigation !== navigationSequence) {
          return null;
        }

        nextRoot = parseSection(html, sectionId);
        metadata = readMetadata(nextRoot);
        productRoot.classList.remove("is-style-loading");
        productRoot.classList.add("is-style-leaving");

        return waitForExitTransition().then(function () {
          return {
            metadata: metadata,
            nextRoot: nextRoot,
          };
        });
      })
      .then(function (result) {
        var activeLink;

        if (!result || currentNavigation !== navigationSequence) {
          return;
        }

        destroyProductWidgets(productRoot);
        result.nextRoot.classList.add("is-style-entering");
        result.nextRoot.setAttribute("data-product-style-swapped", "true");
        result.nextRoot.style.minHeight = previousHeight + "px";
        productRoot.replaceWith(result.nextRoot);

        applyRequestedVariant(result.nextRoot, url);
        reinitializeProductSection(result.nextRoot, sectionId);
        updateDocumentMetadata(result.metadata);

        if (options.historyMode === "push") {
          window.history.pushState(
            {
              productStyleUrl: url.href,
            },
            "",
            url.pathname + url.search + url.hash
          );
        }

        maintainSwitcherPosition(previousTop, result.nextRoot);
        finishEntrance(result.nextRoot);
        setStatus(
          result.nextRoot,
          (result.metadata.productTitle || "Product style") + " loaded"
        );

        activeLink = result.nextRoot.querySelector(
          linkSelector + '[aria-current="page"]'
        );

        if (options.focusAfterLoad && activeLink) {
          activeLink.focus();
        }

        window.dispatchEvent(
          new CustomEvent("tradlands:product:loaded", {
            detail: {
              productRoot: result.nextRoot,
              sectionId: sectionId,
              url: url.href,
            },
          })
        );
      })
      .catch(function (error) {
        if (
          error &&
          (error.name === "AbortError" ||
            currentNavigation !== navigationSequence)
        ) {
          return;
        }

        clearBusyState(productRoot);

        if (options.historyMode === "none") {
          window.location.reload();
        } else {
          window.location.assign(url.href);
        }
      });
  }

  function prefetchStyle(event) {
    var link = getStyleLink(event);
    var productRoot;
    var sectionId;
    var url;
    var cacheKey;

    if (
      !link ||
      link.getAttribute("aria-current") === "page" ||
      (navigator.connection && navigator.connection.saveData)
    ) {
      return;
    }

    productRoot = getProductRoot(link);
    sectionId = getSectionId(productRoot);
    url = getNavigationUrl(link.href);

    if (!productRoot || !sectionId || !url) {
      return;
    }

    cacheKey = getCacheKey(url, sectionId);

    if (sectionCache[cacheKey] || prefetchRequests[cacheKey]) {
      return;
    }

    prefetchRequests[cacheKey] = requestSection(url, sectionId)
      .catch(function () {
        return null;
      })
      .then(function (result) {
        delete prefetchRequests[cacheKey];
        return result;
      });
  }

  function handleSwappedProductHelper(event) {
    var target = event.target;
    var swappedRoot;
    var tabButton;
    var tabId;
    var tabContent;
    var tabButtons;
    var tabContents;
    var index;
    var paymentTerms;
    var afterpayPlacement;
    var afterpayButton;

    if (!target || !target.closest) {
      return;
    }

    swappedRoot = target.closest(
      productRootSelector + '[data-product-style-swapped="true"]'
    );

    if (!swappedRoot) {
      return;
    }

    tabButton = target.closest(".tab-button");

    if (tabButton) {
      tabId = tabButton.getAttribute("data-tab");
      tabContent = tabId && document.getElementById(tabId);
      tabButtons = swappedRoot.querySelectorAll(".tab-button");
      tabContents = swappedRoot.querySelectorAll(".tab-content");

      for (index = 0; index < tabButtons.length; index += 1) {
        tabButtons[index].classList.remove("active");
      }

      for (index = 0; index < tabContents.length; index += 1) {
        tabContents[index].classList.remove("active");
      }

      tabButton.classList.add("active");

      if (tabContent && swappedRoot.contains(tabContent)) {
        tabContent.classList.add("active");
      }

      return;
    }

    if (target.closest("#shoppay-button")) {
      paymentTerms = document.querySelector("shopify-payment-terms");

      if (
        paymentTerms &&
        paymentTerms.shadowRoot &&
        paymentTerms.shadowRoot.getElementById("shopify-installments-cta")
      ) {
        paymentTerms.shadowRoot
          .getElementById("shopify-installments-cta")
          .click();
      }

      return;
    }

    if (target.closest("#afterpay-button")) {
      afterpayPlacement = document.querySelector("square-placement");
      afterpayButton =
        afterpayPlacement &&
        afterpayPlacement.shadowRoot &&
        afterpayPlacement.shadowRoot.querySelector(
          ".afterpay-logo-link button"
        );

      if (afterpayButton) {
        afterpayButton.click();
      }
    }
  }

  document.addEventListener("mouseover", prefetchStyle);
  document.addEventListener("focusin", prefetchStyle);
  document.addEventListener("touchstart", prefetchStyle, {
    passive: true,
  });

  document.addEventListener("click", function (event) {
    var link = getStyleLink(event);
    var url;

    if (!link) {
      handleSwappedProductHelper(event);
      return;
    }

    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    if (link.getAttribute("aria-current") === "page") {
      event.preventDefault();
      return;
    }

    url = getNavigationUrl(link.href);

    if (!url) {
      return;
    }

    event.preventDefault();
    navigateToProduct(url, {
      clickedLink: link,
      focusAfterLoad: event.detail === 0,
      historyMode: "push",
    });
  });

  window.addEventListener("popstate", function () {
    var productRoot = getCurrentProductRoot();
    var currentPath;
    var targetUrl;

    if (!productRoot) {
      return;
    }

    currentPath = getCurrentProductPath(productRoot);

    if (currentPath === window.location.pathname) {
      return;
    }

    targetUrl = new URL(window.location.href);

    if (isKnownStylePath(productRoot, targetUrl.pathname)) {
      navigateToProduct(targetUrl, {
        clickedLink: null,
        focusAfterLoad: false,
        historyMode: "none",
      });
    } else {
      window.location.reload();
    }
  });

  window.addEventListener("pageshow", function () {
    var productRoots = document.querySelectorAll(productRootSelector);
    var index;

    for (index = 0; index < productRoots.length; index += 1) {
      clearBusyState(productRoots[index]);
    }
  });
})();
